import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('RESERVATION_ON_CHANGE_QUERY');

export const onClearQuery = createAction('RESERVATION_ON_CLEAR_QUERY');
